import * as React from "react";
import { CurrentRouteContext } from "src/modules/Routing/auth/CurrentRouteContext";

export const useCurrentRoute = () => {
  return React.useContext(CurrentRouteContext)
}